import React from 'react';
import PropTypes from 'prop-types';

const NumberAbbreviate = ({ number, precision }) => (
  <span className="abbreviated-number">{formatToUnits(number, precision)}</span>
);

NumberAbbreviate.propTypes = {
  number: PropTypes.number.isRequired,
  precision: PropTypes.number
};

const SI_PREFIXES = [
  { value: 0.01, symbol: '' },
  { value: 1, symbol: '' },
  { value: 1e3, symbol: 'k' },
  { value: 1e6, symbol: 'M' },
  { value: 1e9, symbol: 'G' },
  { value: 1e12, symbol: 'T' },
  { value: 1e15, symbol: 'P' },
  { value: 1e18, symbol: 'E' },
];

function customFixed(value, precision)  {
  return  Math.floor((value) * Math.pow(10, precision)) / Math.pow(10, precision);
}

function formatToUnits(value, precision) {
  if (value > -1 && value < 1) return value;
  const prefix = value < 0 ? '-' : '';
  const number = Math.abs(value);
  if (number === 0) return number;
  const tier = SI_PREFIXES.filter((n) => number >= n.value).pop();
  const numberFixed = customFixed((number / tier.value), precision);

  return `${prefix}${numberFixed}${tier.symbol}`;
}

export default NumberAbbreviate;
